module.exports = __webpack_public_path__ + "img/creditcard.cb92a9c5.jpg";